import axios from "axios";

export async function getApplicants({
  sort,
  column,
  limit,
  offset,
  searchQuery,
  post,
  status,
  isCandidateActive,
  id,
  isShared,
  companyId,
  startDate,
  endDate,
  startJoiningDate,
  endJoiningDate
}) {
  const queryParams = {
    limit: limit,
    offset: offset,
    searchQuery: searchQuery || "",
    orderBy: column,
    orderByValue: sort,
    id: id,
    post: post,
    status: status,
    isShared: isShared,
    companyId: companyId,
    isCandidateActive,
    startDate,
    endDate,
    startJoiningDate,
    endJoiningDate
  };
  const response = await axios.get("/apply", { params: queryParams });
  return { count: response.data.count, data: response.data.rows };
}

export async function getApplicationOfCompany({
  id,
  status,
  limit,
  offset,
  searchQuery,
  startDate,
  endDate,
  isCandidateDeleted
}) {
  try {
    const queryParams = {
      id: id,
      status: status,
      limit,
      offset,
      searchQuery,
      startDate,
      endDate,
      isCandidateDeleted
    };
    const response = await axios.get("/apply/company", { params: queryParams });
    return { data: response.data.data, count: response.data.count };
  } catch (e) {
    console.log(e);
  }
}

export async function registerAndApply(application, jobId) {
  try {
    const response = await axios.post(`/apply/quick-apply/${jobId}`, application, {
      headers: {
        "Content-Type": "multipart/form-data",
        Accept: "application/json"
      },
      transformRequest: [(data) => data] // Prevent axios from transforming FormData
    });
    return response.data;
  } catch (error) {
    console.error("Error in registerAndApply:", error);
    throw error;
  }
}

export async function postApplication(application) {
  try {
    const response = await axios.post("/apply", application);
    return response.data;
  } catch (error) {
    console.error("Error submitting application:", error);
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      throw new Error(error.response.data.message || "Failed to submit application");
    } else if (error.request) {
      // The request was made but no response was received
      throw new Error("No response from server. Please try again later.");
    } else {
      // Something happened in setting up the request that triggered an Error
      throw new Error(error.message || "Failed to submit application");
    }
  }
}

export async function updateStatus(id, status) {
  const response = await axios.patch("/apply/status/" + id, status);
  return response;
}

export async function getCandidateApplications(
  candidateId,
  jobPostId,
  searchQuery,
  status,
  fetchCompanyLogo = false
) {
  const response = await axios.get("/apply/candidate", {
    params: {
      id: candidateId,
      searchQuery: searchQuery,
      status,
      jobId: jobPostId,
      fetchCompanyLogo
    }
  });
  const data = Object.values(response.data).map(
    ({
      jp_id,
      jp_candidate_id,
      jp_status,
      jp_company_id,
      jp_jobpost_id,
      jp_is_share_to_company,
      jp_created_at,
      company,
      candidate,
      jobposting
    }) => ({
      jp_id,
      jp_candidate_id,
      jp_created_at,
      jp_jobpost_id,
      jp_company_id,
      jp_status,
      jp_is_share_to_company,
      jp_is_company_deleted: company.jp_is_deleted,
      ...company,
      ...candidate,
      ...jobposting
    })
  );
  return data;
}

export async function getApplicationDetail(id, includeResume, includePhoto) {
  const res = await axios.get("/apply/detail", { params: { id, includeResume, includePhoto } });
  return res.data;
}

export async function getApplicationByStatus(status) {
  const response = await axios.get("/apply/status", { params: { status: status } });
  return response.data;
}

export async function updateApplication(application, id) {
  const response = await axios.put("/apply/" + id, application);
  return response.data;
}

export async function getApplicationCount(status) {
  const response = await axios.get("/apply/count", { params: { status } });
  return response.data;
}

export async function getApplicationCountByStatus({ startDate, endDate }) {
  const response = await axios.get("/apply/count-by-status", {
    params: {
      startDate,
      endDate
    }
  });
  return response.data;
}

export async function updateApplicationInvoice({ id, proformaId, taxId }) {
  const response = await axios.put(`/apply/${id}/invoice`, {
    proformaId,
    taxId
  });
  return response.data;
}

export async function getApplicationWithInvoices({
  limit,
  candidate,
  offset,
  orderBy,
  orderByValue,
  companyId,
  startDate,
  endDate,
  invoiceNo
}) {
  const response = await axios.get("/apply/invoices", {
    params: {
      limit,
      candidate,
      offset,
      orderBy,
      orderByValue,
      companyId,
      startDate,
      endDate,
      invoiceNo
    }
  });
  return response.data;
}

export async function getApplicationActivityForCandidate(candidateId, limit, offset) {
  const response = await axios.get(`/apply/candidate/${candidateId}/activity`, {
    params: {
      limit,
      offset
    }
  });
  return response.data;
}
